<template>
  <div class="payment">
    <div class="container">
      <!-- <Coupon v-model="coupon"/> -->
      <StripeMethod 
        :coupon="coupon"
        :plan="$route.params.plan"
        new-plans-style
        @success="onSuccess"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Axios from 'axios'
import Coupon from '@/components/common/Coupon'
import StripeMethod from '@/components/plans/StripeMethod'

export default {
  data() {
    return {
      coupon: null,
      country: null,
    }
  },
  props: {
    plan: {}
  },
  methods: {
    onSuccess() {
      this.$store.dispatch('user/updateData');
      this.$router.push(`/auth/quick/${this.plan}/thanks`);
    },
  },
  components: {
    Coupon,
    StripeMethod,
  },
  created() {

    // Axios.get('https://ipinfo.io?token=f03faf1b9a44ad')
    //   .then(res => {
    //     this.country = res.data.country;
    //   })
    //   .finally(res => {
    //     this.loading = false;
    //   });

    if(this.$route.params.plan === 'impact') {
      fbq('track', 'Contact', {content_name:'Impact', content_category: 'Our Product' });
    }
    else if(this.$route.params.plan === 'exact') {
      fbq('track', 'Contact', {content_name:'Exact', content_category: 'Our Product' });
    }
    else if(this.$route.params.plan === 'premium') {
      fbq('track', 'Contact', {content_name:'Premium', content_category: 'Our Product' });
    }
    else if(this.$route.params.plan === 'elite') {
      fbq('track', 'Contact', {content_name:'Elite', content_category: 'Our Product' });
    }
  },
}
</script>

<style lang="scss" scoped>

.payment {
  background: #fff;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .container {
    max-width: 400px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
  }

  .app-loading {
    height: unset;
    min-height: 200px;
  }
}

</style>
